import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { memo, useState, useCallback, useMemo, useEffect, useRef, } from 'react';
import classnames from 'classnames';
import { useDropdown } from 'Shared/hooks';
import { Spinner } from 'Shared/components';
import SelectBoxIcon from 'Shared/assets/icons/dropdown.svg';
import { DATASETS_LOADING_MESSAGE } from 'Common/consts';
import { DatasetGroup, DatasetDescription, } from './components';
import { getOpenedGroups } from './utils';
import styles from './DatasetControl.css';
const DatasetControl = ({ data, onChange, isLoading = false, selectedDatasetId = null, label = 'Select dataset', className, }) => {
    const { toggleDropdown, ref, isOpen: isDropdownOpen } = useDropdown();
    const [description, setDescription] = useState(null);
    const [openedGroups, setOpenedGroups] = useState(getOpenedGroups(data));
    const firstRenderedRef = useRef(false);
    useEffect(() => {
        if (firstRenderedRef.current) {
            setOpenedGroups(getOpenedGroups(data));
        }
        firstRenderedRef.current = true;
    }, [data]);
    const handleChange = useCallback((datasetId) => {
        toggleDropdown();
        onChange(datasetId);
    }, [onChange, toggleDropdown]);
    const handleMouseLeave = useCallback(() => setDescription(null), []);
    const handleClick = useCallback((groupId) => {
        setOpenedGroups((currentOpenedGroups) => (Object.assign(Object.assign({}, currentOpenedGroups), { [groupId]: !currentOpenedGroups[groupId] })));
    }, []);
    const handleDropdownToggle = useCallback(() => {
        if (isLoading) {
            return;
        }
        toggleDropdown();
    }, [isLoading, toggleDropdown]);
    const datasetsList = useMemo(() => (data.map(({ id, name, datasets }) => (_jsx(DatasetGroup, { id: id, name: name, datasets: datasets, selectedDatasetId: selectedDatasetId, isOpen: openedGroups[id], onClick: handleClick, onChange: handleChange, onHover: setDescription }, id)))), [
        data,
        openedGroups,
        handleChange,
        handleClick,
        selectedDatasetId,
    ]);
    const containerClassName = classnames(styles.container, {
        [styles.containerOpened]: isDropdownOpen,
    });
    const wrapperClassName = classnames(styles.wrapper, className, {
        [styles.disabled]: isLoading,
    });
    const dropdownIconClassName = classnames(styles.dropdownIcon, {
        [styles.dropdownIconHidden]: isDropdownOpen,
    });
    return (_jsx("div", Object.assign({ ref: ref, className: wrapperClassName, "data-testid": "datasetControl" }, { children: _jsxs("div", Object.assign({ className: containerClassName }, { children: [_jsx("div", Object.assign({ className: styles.controlContainer }, { children: _jsxs("div", Object.assign({ role: "button", className: styles.control, onClick: handleDropdownToggle }, { children: [selectedDatasetId ? (_jsxs("p", Object.assign({ className: styles.title }, { children: [label, _jsx("span", Object.assign({ className: styles.details }, { children: "(see details in dropdown)" }), void 0)] }), void 0)) : (_jsx("p", Object.assign({ className: styles.placeholder }, { children: isLoading ? DATASETS_LOADING_MESSAGE : label }), void 0)), isLoading ? (_jsx(Spinner, { className: styles.spinner, testId: "datasetSpinner" }, void 0)) : (_jsx(SelectBoxIcon, { className: dropdownIconClassName }, void 0))] }), void 0) }), void 0), isDropdownOpen && !isLoading && (_jsxs("div", Object.assign({ className: styles.dataContainer, onMouseLeave: handleMouseLeave, "data-testid": "datasetDropdown" }, { children: [_jsx("div", Object.assign({ className: styles.listContainer }, { children: datasetsList }), void 0), _jsx("div", Object.assign({ className: styles.descriptionContainer }, { children: description && (_jsx(DatasetDescription, { items: description }, void 0)) }), void 0)] }), void 0))] }), void 0) }), void 0));
};
export default memo(DatasetControl);
